if ($('.js-modal-btn').length > 0) {
  $('.js-modal-btn').on('click', (e) => {
    e.preventDefault()
  })

  $('.js-modal-btn').modalVideo({
    channel: 'youtube',
    playsinline: true,
  })
}
